
// @ts-nocheck
import locale_en_46json_1fb58f3f from "#nuxt-i18n/1fb58f3f";
import locale_de_46json_323f1d10 from "#nuxt-i18n/323f1d10";

export const localeCodes =  [
  "en",
  "de"
]

export const localeLoaders = {
  en: [
    {
      key: "locale_en_46json_1fb58f3f",
      load: () => Promise.resolve(locale_en_46json_1fb58f3f),
      cache: true
    }
  ],
  de: [
    {
      key: "locale_de_46json_323f1d10",
      load: () => Promise.resolve(locale_de_46json_323f1d10),
      cache: true
    }
  ]
}

export const vueI18nConfigs = [
  () => import("#nuxt-i18n/7746e39f" /* webpackChunkName: "config_i18n_46config_46ts_7746e39f" */)
]

export const nuxtI18nOptions = {
  restructureDir: "i18n",
  experimental: {
    localeDetector: "",
    switchLocalePathLinkSSR: false,
    autoImportTranslationFunctions: false,
    typedPages: true,
    typedOptionsAndMessages: false,
    generatedLocaleFilePathFormat: "absolute",
    alternateLinkCanonicalQueries: false,
    hmr: true
  },
  bundle: {
    compositionOnly: true,
    runtimeOnly: false,
    fullInstall: true,
    dropMessageCompiler: false,
    optimizeTranslationDirective: true
  },
  compilation: {
    strictMessage: true,
    escapeHtml: false
  },
  customBlocks: {
    defaultSFCLang: "json",
    globalSFCScope: false
  },
  locales: [
    {
      code: "en",
      name: "English",
      files: [
        {
          path: "/home/ubuntu/Lagerverwaltung/i18n/locales/en.json",
          cache: undefined
        }
      ]
    },
    {
      code: "de",
      name: "Deutsch",
      files: [
        {
          path: "/home/ubuntu/Lagerverwaltung/i18n/locales/de.json",
          cache: undefined
        }
      ]
    }
  ],
  defaultLocale: "de",
  defaultDirection: "ltr",
  routesNameSeparator: "___",
  trailingSlash: false,
  defaultLocaleRouteNameSuffix: "default",
  strategy: "prefix_except_default",
  lazy: false,
  langDir: "locales",
  rootRedirect: undefined,
  detectBrowserLanguage: {
    alwaysRedirect: false,
    cookieCrossOrigin: false,
    cookieDomain: null,
    cookieKey: "i18n_redirected",
    cookieSecure: false,
    fallbackLocale: "",
    redirectOn: "root",
    useCookie: true
  },
  differentDomains: false,
  baseUrl: "",
  customRoutes: "page",
  pages: {},
  skipSettingLocaleOnNavigate: false,
  types: "composition",
  debug: false,
  parallelPlugin: false,
  multiDomainLocales: false,
  i18nModules: []
}

export const normalizedLocales = [
  {
    code: "en",
    name: "English",
    files: [
      {
        path: "/home/ubuntu/Lagerverwaltung/i18n/locales/en.json",
        cache: undefined
      }
    ]
  },
  {
    code: "de",
    name: "Deutsch",
    files: [
      {
        path: "/home/ubuntu/Lagerverwaltung/i18n/locales/de.json",
        cache: undefined
      }
    ]
  }
]

export const NUXT_I18N_MODULE_ID = "@nuxtjs/i18n"
export const parallelPlugin = false
export const isSSG = false
export const hasPages = true

export const DEFAULT_COOKIE_KEY = "i18n_redirected"
export const DEFAULT_DYNAMIC_PARAMS_KEY = "nuxtI18nInternal"
export const SWITCH_LOCALE_PATH_LINK_IDENTIFIER = "nuxt-i18n-slp"
/** client **/

/** client-end **/